export const PARENT_CHANNEL_TYPE_ID = 1
export const CHILD_CHANNEL_TYPE_ID = 2

export const channelTypeOptions = [
	{ value: PARENT_CHANNEL_TYPE_ID, text: 'Parent' },
	{ value: CHILD_CHANNEL_TYPE_ID, text: 'Child' }
]
